// The offer and the way back from a receipt. No secret or customer data here.
export const BOARD_CHECKOUT = "https://contextbolt.lemonsqueezy.com/checkout/buy/0aa07b3d-12bc-4e9d-aba2-bfc559dc99af";
export const BILLING_PORTAL = "https://app.lemonsqueezy.com/my-orders";
export interface Subscription {
  id: string;
  email: string;
  status: string;
  updated: number;
  trialEnd: number | null;
  end: number | null;
}
export interface BillingStatus {
  required: boolean;
  allowed: boolean;
  status: string;
  until: number | null;
  reason?: "trial_ended" | "payment_required" | "paused" | "subscription_ended" | "trial_required";
}
/** Only a board's outline is visible behind the locked screen, never its contents or sources. */
export interface BillingPreview {
  name: string;
  themeId: import("./types").ThemeId;
  kind: string;
  tiles: { x: number; y: number; w: number; h: number }[];
}
export interface BillingAccount extends BillingStatus { preview?: BillingPreview | null; checkout?: string; serverTime?: number }
export function subscriptionReason(sub: Subscription | undefined, now = Date.now()): BillingStatus["reason"] {
  if (!sub) return "trial_required";
  if (subscriptionAccess(sub, now)) return undefined;
  if (sub.status === "past_due" || sub.status === "unpaid") return "payment_required";
  if (sub.status === "paused") return "paused";
  if (sub.status === "on_trial" || (sub.trialEnd !== null && sub.end !== null && sub.end <= sub.trialEnd)) return "trial_ended";
  return "subscription_ended";
}
export function subscriptionAccess(sub: Subscription, now = Date.now()): boolean {
  if (sub.status === "active") return true;
  if (sub.status === "on_trial") return sub.trialEnd !== null && sub.trialEnd > now;
  if (sub.status === "cancelled") return sub.end !== null && sub.end > now;
  return false;
}
export function checkoutFor(email?: string | null): string {
  const url = new URL(BOARD_CHECKOUT);
  if (email) url.searchParams.set("checkout[email]", email);
  return url.toString();
}

/** Why someone cancels: one is required before the app cancels, so every cancellation tells us something. */
export const CANCEL_REASONS = [
  { id: "price", label: "It costs too much" },
  { id: "missing", label: "It's missing something I need" },
  { id: "setup", label: "It was hard to set up" },
  { id: "unused", label: "I'm not using it enough" },
  { id: "switched", label: "I found something else" },
  { id: "other", label: "Something else" },
] as const;
export type CancelReason = (typeof CANCEL_REASONS)[number]["id"];
export const isCancelReason = (v: unknown): v is CancelReason => CANCEL_REASONS.some((r) => r.id === v);
/** How much someone can write about why: plenty, and no more. */
export const CANCEL_DETAIL_MAX = 2000;
